import React from 'react';
import { Link } from 'react-router-dom';
import { FaGraduationCap, FaUserMd, FaUsers, FaHandHoldingHeart, FaWhatsapp, FaCheckCircle, FaMapMarkerAlt } from 'react-icons/fa';
import SEO from '../components/SEO';
import { OBRAS_SOCIALES, SEDES, SERVICIOS, CONDICIONES_ATENDIDAS } from '../data/organizacion';
import { breadcrumb, servicio } from '../data/schema';
import cetHero from '../assets/img/temperley/Temp_G1.png';

const gtag_report_conversion = (url) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-16956303663/7KnDCOiB6qIcEK_SspU_',
      'event_callback': function () {
        if (typeof(url) !== 'undefined') {
          window.location = url;
        }
      }
    });
  } else {
    window.location = url;
  }
};

const CET = () => {
  const beneficios = [
    "Educación personalizada según las capacidades de cada alumno",
    "Equipo interdisciplinario de profesionales especializados",
    "Actividades terapéuticas integradas al programa educativo",
    "Apoyo y orientación familiar continua",
    "Instalaciones adaptadas y seguras",
    "Más de 40 años de experiencia en educación especial"
  ];

  const condiciones = CONDICIONES_ATENDIDAS;
  const obrasSociales = OBRAS_SOCIALES.principales.map((os) => os.nombre);
  const noAtendidasTexto = OBRAS_SOCIALES.noAtendidas.join(' ni ');

  return (
    <div className="container">
      <SEO
        title="Centro Educativo Terapéutico (CET) Zona Sur — Mi Lugar"
        description={`CET en Temperley y Glew para niños y jóvenes ${SERVICIOS.cet.edades} con discapacidad intelectual, TEA, Síndrome de Down y más. Trabajamos con la mayoría de las obras sociales (no con ${noAtendidasTexto}).`}
        path="/cet"
        image="/images/temperley.jpg"
        jsonLd={[
          breadcrumb([{ nombre: 'Centro Educativo Terapéutico', path: '/cet' }]),
          servicio({
            nombre: SERVICIOS.cet.nombre,
            descripcion: SERVICIOS.cet.descripcion,
            path: '/cet',
            tipo: 'MedicalTherapy',
            ofrece: condiciones.map((c) => ({ nombre: c, descripcion: `Atención de ${c.toLowerCase()} en el CET de Mi Lugar.` })),
          }),
        ]}
      />
      {/* Header optimizado para SEO */}
      <div className="sede-header">
        <h1>Centro Educativo Terapéutico (CET) en Zona Sur</h1>
        <p>Educación especializada y terapias para niños y jóvenes {SERVICIOS.cet.edades} con discapacidad
          en Temperley y Glew. <strong>Trabajamos con la mayoría de las obras sociales y prepagas.</strong></p>
      </div>

      <section className="sede-info">
        <div className="sede-details">
          <h2>¿Qué es un Centro Educativo Terapéutico?</h2>
          <p>
            Un <strong>Centro Educativo Terapéutico (CET)</strong> es una institución especializada que brinda 
            educación integral y rehabilitación a <strong>niños y jóvenes con discapacidad intelectual</strong> y 
            trastornos del desarrollo.
          </p>
          <p>
            En <strong>Mi Lugar CET</strong>, combinamos educación especial con terapias individuales para 
            potenciar al máximo las capacidades de cada alumno, promoviendo su autonomía e integración social.
          </p>
          <div className="sede-buttons" style={{ marginTop: '20px' }}>
            <a href={SEDES[1].whatsapp} className="btn btn-whatsapp" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp /> Contactar por WhatsApp
            </a>
          </div>
        </div>

        <div className="sede-image">
          <img
            src={cetHero}
            alt="Centro Educativo Terapéutico Mi Lugar — actividades con niños y jóvenes con discapacidad"
            width="1536"
            height="1024"
            loading="lazy"
            decoding="async"
          />
        </div>
      </section>

      {/* Beneficios - Usando el mismo estilo que facilities en Glew.jsx */}
      <section className="sede-facilities">
        <h2 className="section-title">¿Por qué elegir nuestro CET?</h2>
        <div className="facilities-grid">
          {beneficios.map((beneficio, index) => (
            <div key={index} className="facility-item">
              <FaCheckCircle className="facility-icon" />
              <div>
                <p><strong>{beneficio}</strong></p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* A quién atendemos - Usando el mismo estilo */}
      <section className="sede-facilities">
        <h2 className="section-title">¿Para quién está dirigido nuestro Centro Educativo Terapéutico?</h2>
        <p>Atendemos a <strong>niños y jóvenes {SERVICIOS.cet.edades}</strong> con diferentes condiciones:</p>
        <div className="facilities-grid">
          {condiciones.map((condicion, index) => (
            <div key={index} className="facility-item">
              <FaUserMd className="facility-icon" />
              <div>
                <p><strong>{condicion}</strong></p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Programa educativo */}
      <section className="sede-facilities">
        <h2 className="section-title">Nuestro Programa Educativo Terapéutico</h2>
        <div className="facilities-grid">
          <div className="facility-item">
            <FaGraduationCap className="facility-icon" />
            <div>
              <h3>Educación Personalizada</h3>
              <p>Planes educativos individualizados adaptados a las necesidades y capacidades de cada alumno.</p>
            </div>
          </div>
          <div className="facility-item">
            <FaUsers className="facility-icon" />
            <div>
              <h3>Terapias Integradas</h3>
              <p>Psicología, fonoaudiología, terapia ocupacional, musicoterapia y kinesiologia incluidas en el programa.</p>
            </div>
          </div>
          <div className="facility-item">
            <FaHandHoldingHeart className="facility-icon" />
            <div>
              <h3>Apoyo Familiar</h3>
              <p>Orientación y acompañamiento continuo a las familias para fortalecer el trabajo en casa.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Obras Sociales */}
      <section className="sede-facilities">
        <h2 className="section-title">Cobertura por Obras Sociales</h2>
        <p>
          Nuestro <strong>Centro Educativo Terapéutico</strong> trabaja con la mayoría de las obras sociales
          y prepagas — <strong>no con {noAtendidasTexto}</strong>. Contamos con equipo administrativo
          especializado para gestionar autorizaciones y trámites.
        </p>
        <div className="facilities-grid">
          {obrasSociales.map((os, index) => (
            <div key={index} className="facility-item">
              <FaCheckCircle className="facility-icon" />
              <div>
                <h3>{os}</h3>
                <p>Cobertura completa para el programa educativo terapéutico</p>
              </div>
            </div>
          ))}
          <div className="facility-item">
            <FaCheckCircle className="facility-icon" />
            <div>
              <h3>Y muchas más...</h3>
              <p>{OBRAS_SOCIALES.adicionales.join(', ')} y otras. Consultanos por la tuya.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Ubicaciones */}
      <section className="sede-facilities">
        <h2 className="section-title">Nuestras Sedes de Centro Educativo Terapéutico</h2>
        <div className="facilities-grid">
          <div className="facility-item">
            <FaMapMarkerAlt className="facility-icon" />
            <div>
              <h3>CET Temperley</h3>
              <p><strong>Dirección:</strong> A. Gallardo 646, Temperley</p>
              <p><strong>Teléfono:</strong> 11 6565-1675</p>
              <p>Fácil acceso desde Lomas de Zamora, Banfield y Lanús</p>
              <div style={{ marginTop: '10px' }}>
                <Link to="/temperley" className="btn btn-small">Ver sede</Link>
              </div>
            </div>
          </div>
          <div className="facility-item">
            <FaMapMarkerAlt className="facility-icon" />
            <div>
              <h3>CET Glew</h3>
              <p><strong>Dirección:</strong> Av. Hipólito Yrigoyen 22548, Guernica</p>
              <p><strong>Teléfono:</strong> 11 6566-1677</p>
              <p>Atendemos familias de Longchamps, Burzaco, Guernica, Florencio Varela y alrededores</p>
              <div style={{ marginTop: '10px' }}>
                <Link to="/glew" className="btn btn-small">Ver sede</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp Float Button */}
      <a
        href={SEDES[0].whatsapp}
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Escribinos por WhatsApp"
        onClick={(e) => {
          e.preventDefault();
          gtag_report_conversion(SEDES[0].whatsapp);
        }}
      >
        <FaWhatsapp />
      </a>
    </div>
  );
};

export default CET;